import React from 'react';
import 'antd/dist/antd.css';
import { Form, Row, Col, Select } from 'antd';
import { debounce } from "lodash";
class CustomerSearchForm extends React.Component {
  state = {
    countryList: [],
    revisionList: [],
    status: [
      {name: 'All Status', value: ''},
      {name: 'Active', value: 'true'},
      {name: 'Disable', value: 'false'}
    ],
    action: [
      {name: 'All Status', value: ''},
      {name: 'Approved', value: 'approved'},
      {name: 'Rejected', value: 'reject'},
      {name: 'Pending', value: 'to_approved'}

    ],
    channel: [
      {name: 'All Channel', value: ''},
      {name: 'Active', value: 'active'},
      {name: 'Passive', value: 'passive'}
    ],
    aging: [
      {name: 'All Aging', value: ''},
      {name: '<=1Y', value: '1'},
      {name: '<=2Y', value: '2'},
      {name: '>2Y', value: '3'}

    ],

    sortBy: [
      {name: 'Default', value: ''},
    ]
  };

  async componentDidMount() {
    await this.setFieldsValue();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.countryList !== nextProps.countryList) {
      const propsCountryList = JSON.parse(JSON.stringify(nextProps.countryList || []));
      propsCountryList.shift();
      let country = [{ region_code: '', name: 'All Country' }];
      propsCountryList.map((v) => country.push(v));
      this.setState({countryList : country});
    }

    if (this.props.revisionList !== nextProps.revisionList) {
      let revision = [{ id: '', name: 'All Revision' }];
      nextProps.revisionList.map((v) => revision.push(v));
      this.setState({revisionList : revision});
    }
  }

  setFieldsValue = () => {
    this.props.form.setFieldsValue({ // ถ้าไม่มีค่าเริ่มต้นจะว่างเลย ไม่มี allstatus เพราะฉพนั้นควรมี
      search: '',
      status: '',
      channel: '',
      sortBy: '',
      action: '',
      aging: ''
    });
  }

  getFields() { //ตัวที่จะเอาไป render
    const { getFieldDecorator } = this.props.form;
    const children = [
      // <Col key={0} xs={{span: 24}} md={{span: 4}}>
      //   <Form.Item>
      //     {getFieldDecorator('search')(
      //       <Input
      //         type='text'
      //         onChange={this.handleChangeSearch}
      //         prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }}/>}
      //         placeholder="Search Customer"
      //       />,
      //     )}
      //   </Form.Item>
      // </Col>,
      // <Col key={1} xs={{span: 24}} md={{span: 5}}>
      //   <Form.Item label="Country">
      //         {getFieldDecorator('country',{})(
      //           <Select
      //           showSearch
      //           placeholder="Country"
      //           onChange={this.handleChangeCountry}
      //           optionFilterProp="children"
      //           filterOption={(input, option) =>
      //             option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      //           }
      //           style={{ width: '130px' }}
      //         >
      //           {(this.state.countryList || []).map((item, i) => (
      //             <Select.Option key={i} value={item.region_code}>
      //               {item.name}
      //             </Select.Option>
      //           ))}
      //         </Select>
      //         )}
      //   </Form.Item>
      // </Col>,
      // <Col key={2} xs={{span: 24}} md={{span: 5}}>
      //   <Form.Item label="Revision">
      //         {getFieldDecorator('revision',{})(
      //           <Select
      //           placeholder="Revision"
      //           style={{ width: '130px' }}
      //           onChange={this.handleChangeRevision}
      //         >
      //         {(this.state.revisionList || []).map((item, i) => (
      //             <Select.Option key={i} value={item.id}>
      //               {item.name}
      //             </Select.Option>
      //           ))}
      //         </Select>
      //         )}
      //   </Form.Item>
      // </Col>,
      // <Col key={3} xs={{span: 24}} md={{span: 5}}>
      //   <Form.Item label="Status">
      //         {getFieldDecorator('status',{})(
      //           <Select
      //           placeholder="Status"
      //           style={{ width: '130px' }}
      //           onChange={this.handleChangeStatus}
      //         >
      //         {(this.state.status || []).map((item, i) => (
      //             <Select.Option key={i} value={item.value}>
      //               {item.name}
      //             </Select.Option>
      //           ))}
      //         </Select>
      //         )}
      //   </Form.Item>
      // </Col>,
      // <Col key={4} xs={{span: 24}} md={{span: 5}}>
      //   <Form.Item label="Sort By">
      //         {getFieldDecorator('sortBy',{})(
      //           <Select
      //           placeholder="Sort By"
      //           style={{ width: '130px' }}
      //         >
      //         <Select.Option key={1} value={""}>
      //           Default
      //         </Select.Option>
      //         </Select>
      //         )}
      //   </Form.Item>
      // </Col>,


      //new
    <Col key={5} xs={{span: 24}} md={{span: 6}}>
    <Form.Item label="Account Aging">
          {getFieldDecorator('aging',{})(
            <Select
            placeholder="Account Aging"
            style={{ width: '130px' }}
            onChange={this.handleChangeAging}
          >
          {(this.state.aging || []).map((item, i) => ( 
              <Select.Option key={i} value={item.value}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
          )}
    </Form.Item>
    </Col>,
      <Col key={6} xs={{span: 24}} md={{span: 5}}>
      <Form.Item label="Channel">
            {getFieldDecorator('channel',{})(
              <Select
              placeholder="Channel"
              style={{ width: '130px' }}
              onChange={this.handleChangeChannel}
            >
            {(this.state.channel || []).map((item, i) => (
                <Select.Option key={i} value={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
            )}
      </Form.Item>
    </Col>,

    <Col key={7} xs={{span: 24}} md={{span: 5}}>
    <Form.Item label="Status">
          {getFieldDecorator('action',{})(
            <Select
            placeholder="Status"
            style={{ width: '130px' }}
            onChange={this.handleChangeAction}
          >
          {(this.state.action || []).map((item, i) => (
              <Select.Option key={i} value={item.value}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
          )}
    </Form.Item>
    </Col>,
    
    ];

    return children;
  }

  handleChangeSearch = (event) => {
    event.persist();
    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        const text = String(event.target.value).replace(/\s/g, "");
        this.props.form.setFieldsValue({
          search: text
        });
        this.handleSubmit()
      }, 600);
    }

    this.debouncedFn();
  }

  // handleChangeCountry = e => {
  //   this.props.form.setFieldsValue({
  //     country: e
  //   });
  //   this.handleSubmit()
  // }

  // handleChangeRevision = e => {
  //   this.props.form.setFieldsValue({
  //     revision: e
  //   });
  //   this.handleSubmit()
  // }

  // handleChangeStatus = e => {
  //   this.props.form.setFieldsValue({
  //     status: e
  //   });
  //   this.handleSubmit()
  // }

  handleChangeAction = e => {
    this.props.form.setFieldsValue({
      action: e
    });
    this.handleSubmit()
  }

  handleChangeChannel = e => {
    this.props.form.setFieldsValue({
      channel: e
    });
    this.handleSubmit()
  }

  handleChangeAging = e => {
    this.props.form.setFieldsValue({
      aging: e
    });
    this.handleSubmit()
  }

  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (values.search) {
        values.search = String(values.search).replace(/\s/g,"")
      }
      this.props.onSearch(values);
    });
  };

  render() {
    return (
      <Form layout="inline" className="ant-advanced-search-form">
        <Row className="search-desktop" gutter={24}>{this.getFields()}</Row>
      </Form>
    );
  }
}

const Search = Form.create({ name: 'advanced_search' })(CustomerSearchForm);
export default Search;
          


// WEBPACK FOOTER //
// ./src/containers/ApproveBinding/search.js